<template lang="pug">
form(v-on:submit.prevent)
  .modal-card(style="width: auto")
    .modal-card-head
      .modal-card-title {{verbGerund}} {{noun}}
    .modal-card-body
      .field
        .control.is-expanded
          .select.is-fullwidth(v-bind:class="[$v.operator.$error ? 'is-danger' : 'is-success']")
            select(ref="focus" v-model.number="$v.operator.$model")
              option(value="0") Please select an operator
              option(v-bind:value="operator.id" v-for="operator in operators") {{ operator.name }}
        .help.is-danger(v-show="$v.operator.$error && !$v.operator.minValue") Please select an operator
    .modal-card-foot
      button.button.has-text-weight-semibold(v-if="canClose" v-on:click="$parent.close()") Close
      button.button.has-text-weight-semibold.is-primary(v-bind:disabled="$v.$invalid" v-on:click="$parent.close(); impl(json, operator)") {{verbBase}} {{noun}}
</template>

<script>
import { minValue, required } from 'vuelidate/lib/validators'

import ApiMixin from '@/mixins/ApiMixin.vue'
import DeviceMixin from '@/mixins/DeviceMixin.vue'

export default {
  mixins: [
    ApiMixin,
    DeviceMixin
  ],
  props: {
    canClose: {
      default: true,
      required: false,
      type: Boolean
    },
    impl: {
      required: true,
      type: Function
    },
    json: {
      default: null,
      required: false,
      type: Object
    },
    noun: {
      required: true,
      type: String
    },
    operators: {
      required: true,
      type: Array
    },
    verbBase: {
      required: true,
      type: String
    },
    verbGerund: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      operator: 0
    }
  },
  validations: {
    operator: {
      minValue: minValue(1),
      required
    }
  }
}
</script>
